
import { defineComponent } from 'vue';
import { mapGetters } from 'vuex';

export default defineComponent({
  name: "ButtonSaveTemplate",
  emits: ['deleteTemplate'],
  computed: {
    ...mapGetters(['isLoading']),
    isDisabled() {
      return this.isLoading
    }
  },
})
